// * 后端微服务端口名
export const PORT1 = "/manage";
export const PORT2 = "/hooks";
export const PORT3 = "/customer";
